export default "__VITE_ASSET__GakW2SI0__"